// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3ZOEH","signatureBlock":"Footer_signatureBlock__1XAPe","signature":"Footer_signature__1oq5b"};